export const TOGGLE_MODAL    = 'TOGGLE_MODAL'

/*----- Resources -----*/
export const PRODUCERS	  = 'producers'
export const PROFILE_PICS = 'profile_pics'

/*----- Methods -----*/
export const CREATE = "create"
export const DELETE = "delete"
export const UPDATE = "update"